import { render, staticRenderFns } from "./TopNotification.vue?vue&type=template&id=175ac4f1"
import script from "./TopNotification.vue?vue&type=script&lang=js"
export * from "./TopNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports